import { PATHWAYS_JSON_CONTENT_TYPE, sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'
import { FALLBACK_TRANSLATION_LANGUAGES, sortByDisplayOrder } from './translation_languages'
import type { GoalTranslation, GoalTranslationRequest, TranslationLanguage } from './translation_types'

const translationApiUrl = `${goalbookUrls.pathwaysApi}/translation_generation`

export async function getGoalTranslationLanguages(): Promise<TranslationLanguage[]> {
  try {
    const response = await sendHTTPRequest({ url: `${translationApiUrl}/languages`, method: 'GET' })
    return sortByDisplayOrder(await response.json() as TranslationLanguage[])
  } catch (error) {
    console.error('Unable to fetch translation languages', error)
    return FALLBACK_TRANSLATION_LANGUAGES
  }
}

// The server translates its stored goal text unless the user edited it, so only edited text is sent.
function translationRequestBody(request: GoalTranslationRequest) {
  const body: Record<string, unknown> = {
    goal_uuid: request.goalUuid,
    edited: request.isEdited,
    language: request.language,
    content_profile: request.contentProfile,
    beta_mode: request.isBetaMode,
  }
  if (request.isEdited) {
    body.goal_text = request.goalText
  }
  return body
}

export async function translateGoalText(request: GoalTranslationRequest): Promise<GoalTranslation> {
  try {
    const response = await sendHTTPRequest({
      url: `${translationApiUrl}/translate`,
      method: 'POST',
      contentType: PATHWAYS_JSON_CONTENT_TYPE,
      jsonBody: translationRequestBody(request),
    })
    return await response.json() as GoalTranslation
  } catch (error) {
    throw new Error('Failed to translate goal text', { cause: error })
  }
}
